import { Redirect, useLocation } from "react-router-dom";

import { Layout } from "~/v2/components/Layout";
import { FeatureFlags, useFeatureEnabled } from "~/v2/helpers/featureFlags";
import { Path } from "~/v2/path";
import DigitalAssetTransfers from "./index";
import DigitalAssetTransfersWhitelistAddress from "./whitelistAddress";

export const DigitalAssetsTransfersRoute = () => {
  const isTokenizedEquityTrading = useFeatureEnabled(
    FeatureFlags.TOKENIZED_EQUITY_TRADING,
  );

  if (!isTokenizedEquityTrading) {
    return <Redirect to={Path.ROUTE_CRYPTO_TRANSFERS} />;
  }

  return (
    <Layout requireMFAForAllAccounts={true} component={DigitalAssetTransfers} />
  );
};

export const DigitalAssetsWhitelistAddressRoute = () => {
  const location = useLocation();
  const isTokenizedEquityTrading = useFeatureEnabled(
    FeatureFlags.TOKENIZED_EQUITY_TRADING,
  );

  if (!isTokenizedEquityTrading) {
    return (
      <Redirect
        to={{
          pathname: Path.ROUTE_CRYPTO_WHITELIST_ADDRESS,
          search: location.search,
        }}
      />
    );
  }

  return (
    <Layout
      showSearchInHeader={false}
      noHeader={true}
      disableAppMenu={true}
      requireMFAForAllAccounts={true}
      component={DigitalAssetTransfersWhitelistAddress}
    />
  );
};
